import {actions} from './reducer';
import {getParamByName} from '../common/Utils';

class Router {
    store = {};
    history = window.History;
    isFirst = true;

    constructor(_store={}){
        this.store = _store;
        this.title = document.getElementsByTagName('title')[0].innerText;
        this.history.Adapter.bind(window, 'statechange', () => this.getParamSetData() );
    }
    
    init(){
        this.history.Adapter.trigger(window, 'statechange');
    }

    getParamSetData(){
        this.store.dispatch( actions.setIsParamsLoaded( false ) );
        this.findDispatch('detail', actions.setDetail);
        this.findDispatch('page', actions.setPage);
        this.findDispatch('query', actions.setQuery);
        this.findDispatch('favorite', actions.setFavorite);
        
        this.findDispatch('grades', actions.setGrades);
        this.findDispatch('class', actions.setClass);
        this.findDispatch('category1', actions.setCategory1);
        this.findDispatch('category2', actions.setCategory2);
        this.findDispatch('learn', actions.setLearn);
        this.findDispatch('spelltype', actions.setSpelltype);
        this.findDispatch('elemental', actions.setElemental);
        this.findDispatch('card', actions.setCard);
        this.findDispatch('buffcard', actions.setBuffcard);
        this.findDispatch('weapon', actions.setWeapon);
        this.findDispatch('field', actions.setField);
        
        this.findDispatch('craftinputid', actions.setCraftInputId);
        this.findDispatch('craftoutputid', actions.setCraftOutputId);

        this.store.dispatch( actions.setIsParamsLoaded( true ) );
    }

    findDispatch(_key, _action){
        let val = getParamByName(_key);
        if (_key==='detail') {
            val = (val === null)? '': val;
            val = (/<|>/ig.test(val))? '': val;
        }
        if (_key==='page' && !val) {
            val = 1;
        }
        if (val != null) this.store.dispatch( _action(val) );
    }
    
    goMultiParam(_newParamObj={}) {
        let oldParamObj = {};
        document.location.search.substr(1).split('&').map( it => {
            let key = it.split('=')[0];
            let val = it.split('=')[1];
            if(!val) return '';
            if(key==='query') val = decodeURIComponent(val);
            if(key==='grades') val = decodeURIComponent(val);
            if(key==='class') val = decodeURIComponent(val);
            if(key==='learn') val = decodeURIComponent(val);
            if(key==='spelltype') val = decodeURIComponent(val);
            if(key==='elemental') val = decodeURIComponent(val);
            if(key==='card') val = decodeURIComponent(val);
            if(key==='buffcard') val = decodeURIComponent(val);
            if(key==='weapon') val = decodeURIComponent(val);
            oldParamObj[key] = val;
        });
        let lastParam = $.extend(true, oldParamObj, _newParamObj);
        if (lastParam.field) {
            lastParam.field = '';
        }
        this.changeParam($.param(lastParam));
    }

    changeParam(_paramStr=''){
        this.history.pushState( null, this.title, '?' + _paramStr );
    }

} // end of class
export default Router;


/* 
    History.Adapter.bind(window,'statechange',function(){
        var State = History.getState();
    });
    History.pushState({state:1}, "State 1", "?state=1");
    History.replaceState({state:3}, "State 3", "?state=3");
    History.pushState(null, null, "?state=4");
    History.back();
    History.go(2);
*/